import { useContext, useEffect, useState } from "react";
import {
  addYears,
  format,
  getYear,
  isBefore,
  lastDayOfMonth,
  setDate,
  setMonth,
  subDays,
} from "date-fns";
import { useSelector, useDispatch } from "react-redux";
import FileUploadForm from "components/PLCTABS/CompanyOfficialsTab/FileUploadForm";
import DatePickerField from "components/lib/Shared/DatePickerField";
import { Field, Form, Formik } from "formik";
import ValidationError from "components/lib/Shared/ValidationError";

import { ManageModuleContext } from "context/ManageCompanyModuleContext";
import BreadCrumb from "components/lib/Global/BreadCrumb";
import Tabs from "components/lib/Shared/Tabs";
import ApplicantDetails from "./ApplicantDetails";
import ChangeType from "./ChangeType";
import Approvals from "./Approvals";
import BRS from "./BRS";
import Summary from "./Summary";
import Status from "./Status";
import Button from "components/lib/Shared/Button";

const AnnualCompliance = () => {
  const { handleBackToManageYourCompanyDashboard } =
    useContext(ManageModuleContext);

  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [selectedChangeTypes, setSelectedChangeTypes] = useState([]);

  const pages = [
    { name: "Home", href: "#", current: false },
    {
      name: "Maintain a company",
      current: false,
      href: "#",
      handleClick: handleBackToManageYourCompanyDashboard,
    },
    {
      name: "Annual Compliance",
      current: true,
      href: null,
    },
  ];

  const tabs = [
    {
      id: "applicantDetails",
      label: "Applicant Details",
    },
    {
      id: "changeType",
      label: "Change Type",
    },
    {
      id: "summary",
      label: "Summary",
      disabled: selectedChangeTypes.length === 0,
    },
    {
      id: "approvals",
      label: "Approvals",
      disabled: true,
    },
    {
      id: "brs",
      label: "BRS",
      disabled: true,
    },
    {
      id: "status",
      label: "Status",
      disabled: true,
    },
  ];

  const [selectedTab, setSelectedTab] = useState(tabs[0].id);

  useEffect(() => {
    setSelectedTab(tabs[selectedTabIndex].id);
  }, [selectedTabIndex]);

  const handleGoForward = () => {
    if (selectedTabIndex < tabs.length - 1) {
      setSelectedTabIndex(selectedTabIndex + 1);
    }
  };
  const handleGoBack = () => {
    if (selectedTabIndex > 0) {
      setSelectedTabIndex(selectedTabIndex - 1);
    }
  };

  return (
    <div>
      <div className="bg-white container mx-auto px-4 mb-8">
        <div className="">
          <BreadCrumb pages={pages} />
        </div>
      </div>
      <h2 className="font-semibold ">Annual Compliance</h2>
      <Tabs
        tabs={tabs}
        selectedTabIndex={selectedTabIndex}
        setSelectedTabIndex={setSelectedTabIndex}
      />
      {selectedTab === "applicantDetails" && (
        <ApplicantDetails handleGoForward={handleGoForward} />
      )}
      {selectedTab === "changeType" && (
        <ChangeType
          handleGoForward={handleGoForward}
          handleGoBack={handleGoBack}
          selectedChangeTypes={selectedChangeTypes}
          setSelectedChangeTypes={setSelectedChangeTypes}
        />
      )}
      {selectedTab === "summary" && (
        <Summary
          handleGoForward={handleGoForward}
          handleGoBack={handleGoBack}
          selectedChangeTypes={selectedChangeTypes}
        />
      )}
      {selectedTab === "approvals" && (
        <Approvals handleGoForward={handleGoForward} />
      )}
      {selectedTab === "brs" && <BRS handleGoForward={handleGoForward} />}
      {selectedTab === "status" && <Status handleGoForward={handleGoForward} />}
    </div>
  );
};

export default AnnualCompliance;
